import React, { useState } from 'react';
import { useNavigate,Link } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Import the useAuth hook
import { endpoint } from './endpoint';
import './Login.css';
import MainLogo from "./mainlogo.svg";

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { loginUser } = useAuth(); // Use the useAuth hook to access context values

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${endpoint}/gymapp/login.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();

            if (data.status === 'success') {
                // Use the loginUser function from context
                loginUser(data.user);
                navigate('/dashboard');
            } else {
                setError(data.message || 'Login failed');
            }
        } catch (error) {
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <center className="inner-login-container">
                <img src={MainLogo} style={{width:"50px"}}/>
				<h2>Login</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label style={{float:"left"}}>Email</label>
                        <input
						className="form-control"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label style={{float:"left"}}>Password</label>
                        <input
						className="form-control"
                          
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    {error && <div className="error">{error}</div>}
                    <button type="submit" disabled={loading}>
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
                <div className="register-link">
                    <p style={{padding:"10px"}}>No account? <Link to="/register">Register here</Link></p>
                </div>
            </center>
        </div>
    );
};

export default Login;
